<template>
  <v-container fluid class="background-primary">
    <v-row>
      <v-col cols="12" class="colored-card-border pa-12">
        <v-row>
          <v-col cols="12" class="blank-card">
            <v-row>
              <v-col cols="12" class="background-primary-hue text-center font-alt text weight-bold size-medium my-6">
                Augmentez la consommation du panier moyen de vos clients fidélisés sur place et à proximité en envoyant un message automatisé !
              </v-col>
              <v-col cols="12" class="">
                <v-row class="pa-3">
                  <v-col cols="12" xl="8" offset-xl="2" lg="10" offset-lg="1" sm="12" class="scenario-builder-card mb-12">
                    <div class="top-icon">
                      <v-img src="@/assets/images/start.png" />
                    </div>
                    <v-row v-if="step < 5">
                      <v-col cols="12" class="text-center mt-12">
                        <div class="btn btn-rounded btn-w100 m-w400" @click="setStep(1)">
                          {{ stepTypeText }}
                        </div>
                      </v-col>
                      <v-col cols="12" class="text-center mt-6" v-if="step === 1">
                        <div class="scenario-pick-type text-center ma-3 py-6" :class="{
                          selected: scenarioContent.type === 'sms',
                          unselected: scenarioContent.type === 'email',
                        }
                          " @click="pickType('sms')">
                          <div>
                            <v-img class="d-inline-block" width="48" src="@/assets/images/type-sms.svg" />
                          </div>
                          <div class="text font-alt weight-600" :class="{
                            'color-purple-base': scenarioContent.type === null,
                            'color-white': scenarioContent.type === 'sms',
                            'color-grey-disabled': scenarioContent.type === 'email',
                          }
                            ">
                            sms
                          </div>
                        </div>
                        <div class="scenario-pick-type text-center ma-3 py-6" :class="{
                          selected: scenarioContent.type === 'email',
                          unselected: scenarioContent.type === 'sms',
                        }
                          " @click="pickType('email')">
                          <div>
                            <v-img class="d-inline-block" width="48" src="@/assets/images/type-email.svg" />
                          </div>
                          <div class="text font-alt weight-600" :class="{
                            'color-purple-base': scenarioContent.type !== 'email',
                            'color-white': scenarioContent.type == 'email',
                            'color-grey-disabled': scenarioContent.type === 'sms',
                          }
                            ">
                            email
                          </div>
                        </div>
                      </v-col>
                      <v-row v-if="step > 1">
                        <v-col cols="12" class="text-center mt-12">
                          <div class="visual-red-wire" style="height: 50px"></div>
                        </v-col>
                      </v-row>
                    </v-row>
                    <v-row v-if="step < 5">
                      <v-col cols="12" class="text-center mt-8">
                        <div class="btn btn-rounded btn-w100 m-w400" :class="{ 'btn-primary': stepMessageEnabled }" @click="setStep(2)">
                          2. J'entre mon message
                        </div>
                      </v-col>

                      <!-- SMS MODELS -->

                      <v-col cols="12" xl="10" offset-xl="1" sm="10" offset-sm="1" class="mt-6 px-16" v-if="step === 2">
                        <v-row v-if="scenarioContent.type === 'sms'" class="scenario-message-edit-card">
                          <v-col cols="6">
                            <!-- TEXT AREA COMPONENT -->

                            <text-area-counter v-model="scenarioContent.content" class="ma-3" />
                          </v-col>
                          <v-col cols="6" class="py-6">
                            <div class="
                                text
                                size-medium
                                font-alt
                                weight-bold
                                color-orange-dark
                              ">
                              Vous séchez ?
                            </div>
                            <div class="text weight-bold color-black-alt my-3">
                              Commencer avec l’un de nos modèles de
                              notifications personnalisés à envoyer à vos
                              clients pour les faire venir dans votre
                              établissement !
                            </div>

                            <!-- POP OVER -->

                            <v-col align="center" class="text">
                              <v-menu v-model="showSmsModels" hide-details :close-on-content-click="true" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small class="theme-btn models-toggle mr-2" color="#d3d3d3" rounded depressed
                                    @click="resetTextArea()">Annuler
                                  </v-btn>
                                  <v-btn small v-bind="attrs" v-on="on" class="theme-btn models-toggle ml-2"
                                    color="#ffc306" rounded depressed>
                                    Voir les modèles
                                    <v-icon class="animate">expand_more</v-icon>
                                  </v-btn>
                                </template>
                                <v-card class="sms-models" width="450px">
                                  <v-list rounded class="ma-0 pt-6">
                                    <v-subheader>Modèles SMS</v-subheader>
                                    <v-list-item-group v-model="smsModels.text">
                                      <v-list-item v-for="( m, i ) in  smsModels " :key="i" :value="m.text" class="
                                          sms-examples
                                          text
                                          color-black-alt
                                          weight-600
                                          mb-3
                                        " depressed color="#e4e2f8" @click="pickSMSModel(i)">
                                        <v-list-item-content>
                                          <v-list-item-title v-text="m.text" style="overflow-y: auto"></v-list-item-title>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </v-list-item-group>
                                  </v-list>
                                </v-card>
                              </v-menu>
                            </v-col>
                          </v-col>

                          <v-col cols="12" class="text-center">
                            <div>
                              <v-btn class="
                                  theme-btn
                                  shape-rounded
                                  filled-purple
                                  glow
                                  drawer-button
                                " @click="setStep(3, 'sms')">Je valide mon message</v-btn>
                            </div>
                            <div class="
                                text
                                size-small
                                weight-600
                                my-6
                                color-grey-disabled
                              ">
                              Pour information, votre message sms sera envoyé
                              sous forme d’email pour les clients ayant
                              renseigné uniquement leur adresse email lors de
                              l’inscription.
                            </div>
                          </v-col>
                        </v-row>

                        <!-- EMAIL MODELS -->
                        <v-row>

                        </v-row>
                        <v-row v-if="scenarioContent.type === 'email'" class="scenario-message-edit-card">
                          <v-col cols="12">
                            <v-row>
                              <v-col cols="6">
                                <h2>Objet de votre email</h2>
                              </v-col>
                              <v-col cols="6" align="right" class="text">
                                <v-menu v-model="showEmailModels" hide-details :close-on-content-click="true" offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn small v-bind="attrs" v-on="on" class="theme-btn models-toggle ml-2"
                                      color="#ff7461" rounded depressed>
                                      Voir les modèles
                                      <v-icon class="animate">expand_more</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-card class="email-models" width="450px">
                                    <v-list rounded class="ma-0 pt-6">
                                      <v-subheader>Modèles Email</v-subheader>
                                      <v-list-item-group v-model="emailModels.subject">
                                        <v-list-item v-for="( m, i ) in  emailModels " :key="i" :value="m.subject" class="
                                              email-examples
                                              text
                                              color-black-alt
                                              weight-600
                                              mb-3
                                            " depressed color="#e4e2f8" @click="pickEmailModel(i)">
                                          <v-list-item-content>
                                            <v-list-item-title v-text="m.subject"
                                              style="overflow-y: auto"></v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list-item-group>
                                    </v-list>
                                  </v-card>
                                </v-menu>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field class="ma-3" placeholder="Tapez votre objet ici." outlined rounded
                                  v-model="scenarioContent.subject">
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <h2 class="pb-3">Votre message</h2>
                            <v-divider></v-divider>
                            <editor-menu-bar :editor="editor">
                              <div class="editor-bar" slot-scope="{ commands }">
                                <v-btn icon @click="commands.bold">
                                  <v-icon>format_bold</v-icon>
                                </v-btn>
                                <v-btn icon @click="commands.italic">
                                  <v-icon>format_italic</v-icon>
                                </v-btn>
                                <v-btn icon @click="commands.strike">
                                  <v-icon>format_strikethrough</v-icon>
                                </v-btn>
                                <v-btn icon @click="commands.underline">
                                  <v-icon>format_underline</v-icon>
                                </v-btn>
                                <v-btn tile depressed elevation="0" @click="commands.heading({ level: 1 })">
                                  <strong>h1</strong>
                                </v-btn>
                                <v-btn tile depressed elevation="0" @click="commands.heading({ level: 2 })">
                                  <strong>h2</strong>
                                </v-btn>
                                <v-btn tile depressed elevation="0" @click="commands.heading({ level: 3 })">
                                  <strong>h2</strong>
                                </v-btn>
                                <v-btn tile depressed elevation="0" @click="commands.heading({ level: 4 })">
                                  <strong>h4</strong>
                                </v-btn>
                                <v-btn tile depressed elevation="0" @click="commands.heading({ level: 5 })">
                                  <strong>h5</strong>
                                </v-btn>
                                <v-btn icon @click="commands.bullet_list()">
                                  <v-icon>format_list_bulleted</v-icon>
                                </v-btn>
                                <v-btn icon @click="commands.ordered_list()">
                                  <v-icon>format_list_numbered</v-icon>
                                </v-btn>
                                <v-btn icon @click="commands.blockquote()">
                                  <v-icon>format_quote</v-icon>
                                </v-btn>
                                <v-menu :close-on-content-click="false" style="max-width: 200px"
                                  content-class="emoji_select" right :offset-y="true">
                                  <template v-slot:activator="{ on }">
                                    <button icon tile elevation="0" v-on="on">
                                      😃
                                    </button>
                                  </template>
                                  <div class="text-center pa-2" id="emoji-picker">
                                    <v-btn icon small v-for="( emoji, i ) in  emojis " :key="i"
                                      @click="addEmoji(emoji.text)" class="">
                                      <span class="emoji-item">{{
                                        emoji.text
                                      }}</span>
                                    </v-btn>
                                  </div>
                                </v-menu>
                              </div>
                            </editor-menu-bar>
                            <editor-content :editor="editor" class="wysiwyg-content hasPicked"
                              v-html="scenarioContent.content" />
                          </v-col>
                          <v-col cols="12" class="pa-3">
                            <h2 class="pb-3">Mentions légales</h2>
                            <v-textarea v-model="scenarioContent.legal_mention" height="150" outlined hide-details=""
                              placeholder="Entrez si besoin, vos mentions légales.">
                            </v-textarea>
                          </v-col>

                          <!-- EMAIL PREVIEW -->

                          <v-col md="6" sm="12" align="center">
                            <v-dialog class="theme-dialog" v-model="showEmailPreview"
                              transition="dialog-bottom-transition" width="800px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" class="
                                    theme-btn
                                    shape-rounded
                                    glow
                                    drawer-button
                                  ">Aperçu de mon email</v-btn>
                              </template>
                              <v-card>
                                <v-system-bar color="#6b5cd7" dark>Aperçu de mon message
                                  <v-spacer></v-spacer>
                                  <v-icon @click="showEmailPreview = false">close</v-icon>
                                </v-system-bar>
                                <v-row class="ma-0 pt-0">
                                  <v-col cols="1" align="center" class="no-padding">
                                    <v-avatar color="#ebedf4" size="45"><img
                                        src="https://cdn.vuetifyjs.com/images/john.jpg" alt="PA" /></v-avatar>
                                  </v-col>
                                  <v-col cols="11" class="no-padding">
                                    <v-card-text class="ma-0 pa-0"><strong class="grey--text">Envoyé à:</strong>
                                      contact@1glink.fr</v-card-text><v-divider />
                                    <v-card-text class="ma-0 pa-0"><strong class="grey--text">Objet:</strong>
                                      {{ scenarioContent.subject }}</v-card-text><v-divider />
                                    <v-col cols="12" align="center">
                                      <v-card-text class="emailMessage black--text">
                                        <div v-html="editor.getHTML()"></div>
                                      </v-card-text>
                                      <v-card-text class="white--text">{{
                                        scenarioContent.legal_mention
                                      }}</v-card-text>
                                    </v-col>
                                    <v-col cols="11" align="center" class="ml-6">
                                      <v-btn outlined class="
                                          theme-btn
                                          shape-rounded
                                          mr-2
                                          email-modify
                                          #6b5cd7--text
                                        " @click="showEmailPreview = false">Modifier</v-btn>
                                      <v-btn class="
                                          theme-btn
                                          shape-rounded
                                          filled-purple
                                          ml-2
                                        " @click="setStep(3, 'email')">Je valide mon message</v-btn>
                                    </v-col>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-dialog>
                          </v-col>
                          <v-col md="6" sm="12" align="center">
                            <v-btn class="
                                theme-btn
                                shape-rounded
                                filled-purple
                                glow
                                drawer-button
                              " @click="setStep(3, 'email')">Je valide mon message</v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-row v-if="step > 2">
                        <v-col cols="12" class="text-center mt-12">
                          <div class="visual-red-wire" style="height: 50px"></div>
                        </v-col>
                      </v-row>
                    </v-row>
                    <v-row v-if="step < 5">
                      <v-col cols="12" class="text-center mt-8">
                        <div class="btn btn-rounded btn-w100 m-w400">
                          3. Date, heure, choix de la liste d'envoi
                        </div>
                      </v-col>
                      <v-col cols="12" xl="10" offset-xl="1" sm="10" offset-sm="1" class="mt-6 px-16" v-if="step === 3">
                        <v-row class="scenario-title-edit-card">
                          <!-- DATE TIME START -->
                          <v-col cols="6">
                            <v-menu v-model="showStartDate" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="scenario.start_date" label="Date d'envoi"
                                  prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="scenario.start_date" @input="showStartDate = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-menu ref="startTimeMenu" v-model="showStartTime" :close-on-content-click="false"
                              :nudge-right="40" :return-value.sync="scenario.start_time" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="scenario.start_time" label="Heure d'envoi"
                                  prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs"
                                  v-on="on"></v-text-field>
                              </template>
                              <v-time-picker v-if="showStartTime" v-model="scenario.start_time" format="24hr" full-width
                                @click:minute="$refs.startTimeMenu.save(scenario.start_time)"></v-time-picker>
                            </v-menu>
                          </v-col>

                          <v-divider></v-divider>

                          <!-- DATE TIME END -->
                          <!-- <v-col cols="6">
                            <v-menu v-model="showEndDate" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="scenario.end_date" label="Date de fin" prepend-icon="mdi-calendar"
                                  readonly v-bind="attrs" v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="scenario.end_date" @input="showEndDate = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-menu ref="endTimeMenu" v-model="showEndTime" :close-on-content-click="false"
                              :nudge-right="40" :return-value.sync="scenario.end_time" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="scenario.end_time" label="Heure de fin"
                                  prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs"
                                  v-on="on"></v-text-field>
                              </template>
                              <v-time-picker use-seconds v-if="showEndTime" v-model="scenario.end_time" format="24hr" full-width
                                @click:second="$refs.endTimeMenu.save(scenario.end_time)"></v-time-picker>
                            </v-menu>
                          </v-col>

                          <v-divider></v-divider> -->

                          <!-- SEGMENTS -->
                          <v-col cols="12">
                            <h3>Les segments</h3>
                          </v-col>
                          <v-row>
                            <v-col cols="4" :key="`segment-${segment.id}`" v-for="segment in segments">
                              <v-switch v-model="scenario.segments" :label="segment.label" :value="segment.id"></v-switch>
                            </v-col>
                          </v-row>
                        </v-row>
                        <v-row>
                          <v-col cols="12" class="text-center mt-6">
                            <v-btn class=" theme-btn shape-rounded filled-purple glow drawer-button" @click="setStep(4)">Valider
                              <v-icon class="ml-3">done</v-icon></v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="step < 5">
                      <v-col cols="12" class="text-center mt-8">
                        <div class="btn btn-rounded btn-w100 m-w400">
                          4. Récapitulatif
                        </div>
                      </v-col>
                      <v-col cols="12" xl="10" offset-xl="1" sm="10" offset-sm="1" class="mt-6 px-16" v-if="step === 4">
                        <v-row class="scenario-title-edit-card">
                          <v-col cols="12" class="px-12">
                            <v-text-field placeholder="Tapez le nom de votre scenario" outlined rounded hide-details=""
                              v-model="scenario.name">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" class="text-center mt-6">
                            <v-btn class="
                                theme-btn
                                shape-rounded
                                filled-purple
                                glow
                                drawer-button
                              " @click="setStep(5)">Créer la campagne
                              <v-icon class="ml-3">done</v-icon></v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="step === 5">
                      <v-col cols="12" xl="10" offset-xl="1" sm="10" offset-sm="1" class="text-center mt-12">
                        <div class="
                            text
                            size-xxlarge
                            weight-bold
                            color-purple-base
                          ">
                          Félicitations
                        </div>
                        <div class="text size-large">
                          Votre campagne est enregistrée !
                        </div>
                        <div class="text size-medium mt-6">
                          Vous pouvez dès à présent activer votre campagne en
                          lui appliquant une date et les tranches horaires
                          fréquentées par vos client :
                        </div>
                        <!-- <div class="mt-8 mb-6">
                          <v-btn class="
                              theme-btn
                              shape-rounded
                              filled-purple
                              glow
                              drawer-button
                            " @click="activateCampaign()">Activer ma campagne</v-btn>
                        </div> -->
                        <div class="mt-8 mb-6">
                          <v-btn class="
                              theme-btn
                              shape-rounded
                              filled-purple
                              glow
                              drawer-button
                            " @click="setStep(1)">Créer une autre campagne de type {{ scenarioContent.type }}</v-btn>
                        </div>
                        <div class="mb-6">
                          <v-btn @click="goToManage()" class="
                              theme-btn
                              shape-rounded
                              filled-purple
                              glow
                              drawer-button
                            ">Gérer mes campagnes</v-btn>
                        </div>
                        <div class="text size-medium mt-6 color-orange-dark">
                          Attention, votre campagne ne sera pas activée, tant que
                          ses dates et tranches horaires ne seront pas
                          paramétrées.
                        </div>
                      </v-col>
                    </v-row>
                    <div class="bottom-icon">
                      <v-img src="@/assets/images/finish.png" />
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  Heading,
  ListItem,
  BulletList,
  Blockquote,
  OrderedList,
} from "tiptap-extensions";
import TextAreaCounter from "./components/text-area-counter.vue";

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    TextAreaCounter,
  },
  data: () => {
    return {
      scenario: {
        id: 0,
        name: '',
        start_date: null,
        start_time: null,
        end_date: "1970-01-01",
        end_time: "00:00",
        start_datetime: null,
        end_datetime: "1970-01-01 00:00",
        segments: [],
        is_active: true,
        is_draft: true,
        owner_id: 0,
      },
      scenarioContent: {
        type: null,
        subject: '',
        content: '',
        legal_mention: '',
        send_after: null,
      },
      step: 1,
      showSmsModels: false,
      showEmailModels: false,
      showEmailPreview: false,
      showStartDate: false,
      showStartTime: false,
      showEndDate: false,
      showEndTime: false,
      smsModels: [
        {
          text: "Bonjour {{firstname}}, rendez-vous dans notre établissement pour obtenir vos récompenses grace à votre fidélité !",
        },
        {
          text: "{{firstname}}, vous faites parti de nos clients les plus fidèles ! Pour fêter cela nous vous offrons une récompense. Venez faire un tour dans notre établissement pour en profiter !",
        },
        {
          text: "Si vous recevez ce message, c’est que vous êtes une personne exceptionnelle {{firstname}} ! Une surprise vous attend sur place, à tout de suite dans notre établissement !",
        },
      ],
      emailModels: [
        {
          subject: "Rendez-vous à l'établissement",
          body: `Bonjour {{firstname}},

rendez-vous dans notre établissement pour obtenir vos récompenses grâce à votre fidélité.

Bien cordialement,`,
        },
        {
          subject: "Votre récompense vous attend",
          body: `Bonjour {{firstname}},

Vous faites parti de nos clients les plus fidèles ! Pour fêter cela nous vous offrons une récompense. Venez faire un tour dans notre établissement pour en profiter !

Bien cordialement,`,
        },
        {
          subject: "Vous êtes exceptionnel",
          body: `Bonjour {{firstname}},

Si vous recevez ce message, c’est que vous êtes une personne exceptionnelle! Une surprise vous attend sur place, à tout de suite dans notre établissement !

Bien cordialement,`,
        },
      ],
      editor: null,
      emojis: [
        { text: "😃" },
        { text: "😉" },
        { text: "😋" },
        { text: "😎" },
        { text: "😍" },
        { text: "🙄" },
        { text: "😑" },
        { text: "🤔" },
        { text: "😥" },
        { text: "🤐" },
        { text: "😫" },
        { text: "😲" },
        { text: "😭" },
        { text: "😡" },
        { text: "😬" },
        { text: "😴" },
      ],
    };
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new Bold(),
        new Italic(),
        new Link(),
        new Strike(),
        new Underline(),
        new Heading(),
        new ListItem(),
        new BulletList(),
        new Blockquote(),
        new OrderedList(),
      ],
      content: "",
    });
    this.scenario.owner_id = this.managerId
  },
  beforeUnmount() {
    this.editor.destroy();
  },
  computed: {
    stepTypeText() {
      if (this.scenarioContent.type === "sms") {
        return "1. Je veux envoyer un SMS";
      } else if (this.scenarioContent.type === "email") {
        return "1. Je veux envoyer un Email";
      } else {
        return "1. Je veux envoyer un ...";
      }
    },
    stepMessageEnabled() {
      return this.scenarioContent.type !== null;
    },
    segments() {
      return this.$store.state.segments.list
    },
    managerId() {
      return this.$store.state.auth.users.data.user_id;
    },
  },
  methods: {
    resetTextArea() {
      this.scenarioContent.subject = "";
      this.scenarioContent.content = "";
    },
    goToManage() {
      this.$router.push({ name: "ManageWorkflow" }).catch(() => { });
    },
    pickType(type) {
      this.scenarioContent.type = type;
    },
    validateScenario() {
      let result = ""
      
      if (!this.scenario.name) {
        result += "Le nom est manquant.\n\r"
      }
      if (!this.scenario.start_date) {
        result += "La date de début est manquante.\n\r"
      }
      if (!this.scenario.start_time) {
        result += "L'heure de début est manquante.\n\r"
      }
      if (!this.scenarioContent.type) {
        result += "Le type est manquant.\n\r"
      }
      if (!this.scenarioContent.content) {
        result += "Le contenu est manquant.\n\r"
      }
      if (result) {
        this.$store.commit('ui/triggerAlert', {
            type: 'error',
            msg: result
        }, {root: true});
        return false
      }
      return true
    },
    setStep(step, type) {
      if (step === 3) {
        if (type === "email") {
          this.scenarioContent.content = this.editor.getHTML();
          this.scenarioContent.type = type;
        } else {
          this.scenarioContent.type = type;
        }
      } else if (step === 4) {
        this.scenario.start_datetime = this.scenario.start_date + " " + this.scenario.start_time
        this.scenario.end_datetime = this.scenario.end_date + " " + this.scenario.end_time
      } else if (step === 5) {
        if (this.validateScenario()) {
          this.$store.dispatch("scenarios/addScenario", { scenario: this.scenario, scenarioContent: this.scenarioContent })
            .then((response) => {
              this.scenario = response
            })
        } else {
          return
        }
      }
      this.step = step
    },
    activateCampaign() {
      if (this.scenario.id) {
        this.$store.dispatch(`scenarios/enableScenario`, {
          scenario_id: this.scenario.id,
        })
      }
    },
    pickSMSModel(index) {
      this.scenarioContent.content = this.smsModels[index].text;
    },
    pickEmailModel(index) {
      this.scenarioContent.subject = this.emailModels[index].subject;
      this.editor.setContent(this.emailModels[index].body)
    },
    addEmoji(emoji) {
      const transaction = this.editor.state.tr.insertText(emoji);
      this.editor.view.dispatch(transaction);
    },
  },
};
</script>

<style lang="scss">
.colored-card-border {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;

  .visual-red-wire {
    display: inline-block;
    width: 5px;
    background-color: #ff7461;
  }

  .blank-card {
    border-radius: 7.5px;
    background-color: #fff;

    .scenario-builder-card {
      border-radius: 50px;
      background-color: #f0f0f0;
      position: relative;
      padding-bottom: 80px;

      .top-icon {
        position: absolute;
        top: -30px;
        right: calc(50% - 30px);
        border: 10px solid white;
        border-radius: 50%;
      }

      .bottom-icon {
        position: absolute;
        bottom: -30px;
        right: calc(50% - 30px);
        border: 10px solid white;
        border-radius: 50%;
      }

      .step-title {
        display: inline-block;
        color: white;
        padding: 10px 40px;
        border-radius: 25px;

        &:not(.current) {
          background: #ffc306;
        }

        &.current {
          background-color: $color-secondary;
        }

        &.active {
          background-color: $color-secondary;
          cursor: pointer;
        }
      }

      .scenario-pick-type {
        display: inline-block;
        cursor: pointer;
        padding: 14px 28.5px 14px 27.5px;
        border-radius: 15px;
        box-shadow: 1.9px 2.9px 5px 0 rgba(51, 51, 51, 0.14);
        border: solid 4px $color-primary;
        background-color: #f7f7f7;
        transition-duration: 0.2s;
        width: 170px;

        &.unselected {
          border: solid 4px rgba(134, 131, 131, 0.4);
          background-color: #e4e4e4;
        }

        &.selected {
          background-color: $color-primary;
          border: solid 4px $color-primary;
        }
      }

      .scenario-message-edit-card {
        border-radius: 6px;
        box-shadow: 1.9px 2.9px 5px 0 rgba(51, 51, 51, 0.14);
        background-color: #fff;

        .sms-examples {
          cursor: pointer;
          padding: 10px 40.5px 8px 15.5px;
          border-radius: 12.5px;
          background-color: #e8e8e8;

          &.picked {
            background-color: #e4e2f8;
          }
        }
      }

      .scenario-title-edit-card {
        padding: 24px 16px 26px 15.5px;
        border-radius: 6px;
        box-shadow: 1.9px 2.9px 5px 0 rgba(51, 51, 51, 0.14);
        background-color: #fff;
      }
    }
  }
}

#emoji-picker {
  background-color: white;
  max-width: 200px;

  .emoji-item {
    font-size: 18px;
    color: black !important;
  }
}

.models-toggle {
  color: white !important;

  i {
    transition-duration: 0.2s;
  }

  &[aria-expanded="true"] {
    i {
      transform: rotate(180deg);
    }
  }
}

.ProseMirror {
  padding: 6px;
  min-height: 200px;
  border: solid grey 0.1px;
  border-radius: 6px;
}

.hasPicked {
  margin-bottom: 10px;
}

.emailMessage {
  background-color: white;
}

.emailMentions {
  background-color: #6b5cd7;
}

.v-input__append-inner {
  margin-top: 14px !important;
}

.no-padding {
  margin-top: 1px !important;
  padding-top: 0px !important;
}

.email-modify {
  border: solid #6b5cd7;
  color: #6b5cd7;
}

.warning-title {
  font-size: 21px;
  color: #6f52eb;
}

.warning-bold {
  color: green;
  font-weight: bold;
}

.warning-icon {
  color: #6f52eb !important;
}

.max-char {
  color: #fe675e !important;
}

.v-tooltip__content {
  background-color: #6f52eb !important;
}
.m-w400 {
  max-width: 400px;
}
// .sms-models {
//   height: auto;
//   width: 440px;
// }
// .scroll {
//   overflow-y: scroll;
// }
</style>